export const elementValuesFinance = [
  { preselect: false, label: "36 Monate", value: 36, name: "terms" },
  { preselect: false, label: "48 Monate", value: 48, name: "terms" },
  { preselect: true, label: "54 Monate", value: 54, name: "terms" },
  { preselect: false, label: "60 Monate", value: 60, name: "terms" },
  { preselect: false, label: "72 Monate", value: 72, name: "terms" },
];
export const elementValuesLeasing = [
  { preselect: false, label: "24 Monate", value: 24, name: "terms" },
  { preselect: true, label: "30 Monate", value: 30, name: "terms" },
  { preselect: false, label: "36 Monate", value: 36, name: "terms" },
  { preselect: false, label: "42 Monate", value: 42, name: "terms" },
  { preselect: false, label: "48 Monate", value: 48, name: "terms" },
  { preselect: false, label: "60 Monate", value: 60, name: "terms" },
];
export const elementValuesCustomerType = [
  {
    preselect: false,
    label: "Privat",
    type: "private",
    value: 2,
    icon: "2",
    name: "trade",
  },
  {
    preselect: true,
    label: "Gewerblich",
    type: "business",
    value: 1,
    icon: "57",
    name: "business",
  },
];
export const elementValuesCalculatorType = [
  {
    preselect: false,
    label: "Ballonkredit",
    value: "financing",
    icon: "57",
    type: "financing",
    name: "financing",
  },
  {
    preselect: true,
    label: "Leasing",
    value: "leasing",
    icon: "2",
    type: "leasing",
    name: "leasing",
  },
];
